import {
  Button,
  Card,
  FloatButton, Form, Modal, Radio,
  Checkbox, Select, InputNumber, DatePicker, notification
} from "antd";
import React, {useEffect, useState} from "react";
import "../../styles/HomeTabSwitchingStyle.css";
import {
  BreakfastOrderContext,
  LunchOrderContext,
} from "../../utils/helper/context/OrderContext";
import CheckAuth from "../authentication/common/hooks/CheckAuth";
import HolidayEvent from "../holidayEvent/HolidayEvent";
import NoticeCard from "../notice/NoticeCard";
import CurrentDateMealListLayout from "./mealList/CurrentDateMealListLayout";
import HomeTabLayout from "./switchingTabs/HomeTabLayout";
import moment from "moment";
import dayjs from "dayjs";
import axios from "axios";

export default function ClientHomeLayout({ orderPlacingInstructionMessage }) {
  const [api, contextHolder] = notification.useNotification();
  const { Meta } = Card;
  const [breakfastOrder, setBreakfastOrder] = useState();
  const [lunchOrder, setLunchOrder] = useState();
  const [size, setSize] = useState('large');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const [isCancel, setIsCancel] = useState(false);
  const [required, setRequired] = useState(false);
  const [actionDate, setActionDate] = useState(moment().add(1, 'days').format("YYYY-MM-DD"));
  const initialOrder = {
    action: "place",
    meals: ["Breakfast", "Lunch"],
    till_date: moment().add(1, 'days').format("YYYY-MM-DD")
  }
  const [orderObj, setOrderObj] = useState(initialOrder);
  const plainOptions = ['Breakfast', 'Lunch'];
  const dayOptions = [
    { value: '0', label: 'Custom Day' },
    { value: '1', label: 'Next Week' },
    { value: '2', label: 'Next Month' },
    { value: '3', label: 'Till Date' },
  ];

  const openNotificationWithIcon = (type, message, description) => {
    api[type]({
      message,
      description
    });
  };

  const handleOk = (values) => {
    if(orderObj.meals.length===0){
      setRequired(true);
      return;
    }
    setIsModalOpen(false);
    setIsConfirmModalOpen(true);
  }

  const manageBulkOrder = async () => {
    try {
      const base_url = process.env.REACT_APP_BASE_URL;
      const accessToken = sessionStorage.getItem("accessToken");

      let variables = {
        action: orderObj.action,
        meals: orderObj.meals,
        till_date: orderObj.till_date
      }
      const response = await axios.post(
          `${base_url}/api/v1/client/order/bulk`,
          variables,
          {
            headers: {Authorization: `Bearer ${accessToken}`},
          }
      );
      const {data} = response;
      openNotificationWithIcon('success', "SUCCESS", data.message);
      setTimeout(()=>{
        window.location.reload();
      },3000)
    } catch (error) {
      // Handle errors
      openNotificationWithIcon('error', "ERROR", "Order couldn't be created");
    }
  };

  const handleConfirmOk = (values) => {
    setIsConfirmModalOpen(false);
    manageBulkOrder();
  }

  const handleCancel = () => {
    setIsModalOpen(false);
  }

  const handleConfirmCancel = () => {
    setIsConfirmModalOpen(false);
  }

  const onActionChange = (e) => {
    setOrderObj({...orderObj, action: e.target.value})
    setIsCancel(e.target.value=='cancel')
  }

  const onMealChange = (checkedValues) => {
    setOrderObj({...orderObj, meals: checkedValues})
  }

  const onDateChange = (date, dateString) => {
    setActionDate(dateString);
    setOrderObj({...orderObj, till_date: dateString})
  }

  const disabledDate = (current) => {
    return current && current < dayjs().endOf('day');
  };

  let date = "";

  const onSelectDay = (value) => {
    switch (value){
      case "0":
        setContent(<InputNumber style={{ width: 150 }} addonAfter="Days" min={1} onChange={onDayChange} defaultValue={1}/>);
        date = moment().add(1, 'days').format("YYYY-MM-DD");
        setActionDate(date);
        setOrderObj({...orderObj, till_date: date})
            break;
      case "1":
        setContent(<></>)
        date = moment().add(7, 'days').format("YYYY-MM-DD");
        setActionDate(date);
        setOrderObj({...orderObj, till_date: date})
            break;
      case "2":
        setContent(<></>)
          date = moment().add(1, 'months').format("YYYY-MM-DD");
        setActionDate(date);
        setOrderObj({...orderObj, till_date: date})
            break;
      case "3":
        setContent( <DatePicker defaultValue={dayjs(dayjs().format("YYYY-MM-DD"), "YYYY-MM-DD")} disabledDate={disabledDate} onChange={onDateChange} />)
        date = moment().format("YYYY-MM-DD");
        setActionDate(date);
            break;
      default:
        setContent(<></>)
            break;
    }
  }

  const onDayChange = (e) => {
    date = moment().add(e, 'days').format("YYYY-MM-DD");
    setActionDate(date);
    setOrderObj({...orderObj, till_date: date})
  }

  const openModal = () => {
    setIsModalOpen(true)
    setOrderObj(initialOrder)
    onSelectDay("0")
  }

  const [content, setContent] = useState(<InputNumber style={{ width: 150 }} addonAfter="Days" min={1} onChange={onDayChange} defaultValue={1}/>);

  CheckAuth();



  return (
    <>
      {contextHolder}
      <NoticeCard />
      
      <HolidayEvent />

      <BreakfastOrderContext.Provider value={{ breakfastOrder, setBreakfastOrder }} >

        <LunchOrderContext.Provider value={{ lunchOrder, setLunchOrder }}>
          
          <div>

            <div className="header-section" >
              
              <Card className="responsive-home-card" >
                <Meta title="Order Placement Instructions" description={orderPlacingInstructionMessage} />
              </Card>

              <CurrentDateMealListLayout orderPlacingInstructionMessage={orderPlacingInstructionMessage} />

            </div>

            <div className="advanced-ordering">
              <Button size={size} type="primary" shape="round" className="advanced-button" onClick={openModal}>Advanced Order Place/Cancel</Button>
            </div>

            <Modal title={<h4 className="content-label">Order Place/Cancel</h4>} destroyOnClose={true} open={isModalOpen} onOk={handleOk} onCancel={handleCancel} style={{color: ""}}>
              <hr/>
              <div className="order-place-content">
                <span className="message-text">Please Note: Any action regarding this will be applicable to only future records/dates. Present or past data will not be effected thorugh this.</span>
                <div className="content-section">
                  <label className="content-label">Choose Action</label>
                  <Radio.Group onChange={onActionChange} value={orderObj.action}>
                    <Radio value="place">Place</Radio>
                    <Radio value="cancel">Cancel</Radio>
                  </Radio.Group>
                  <span className="hint-text">Select which action you want to take for your future order(s)</span>
                  {isCancel?<div className="warning-text">Please beware, you are going to Delete your upcoming orders!</div>:''}
                </div>
                <div className="content-section">
                  <label className="content-label">Select Meal Type</label>
                  <Checkbox.Group options={plainOptions} defaultValue={orderObj.meals} onChange={onMealChange} />
                  <span className="hint-text">Select on which meal type you want to take action</span>
                  {required?<div className="warning-text">Please select one record</div>:''}
                </div>
                <div className="content-section">
                  <label className="content-label">Select Day(s)</label>
                  <div className="date-selection-content">
                    <Select
                        defaultValue="0"
                        style={{ width: 150 }}
                        onChange={onSelectDay}
                        options={dayOptions}
                    />
                    {content}
                  </div>
                  <span className="hint-text">Select until which date, you want to take action</span>
                </div>
                <div className="content-section">
                  <label style={{fontWeight: "bold"}}>Action will be taken till Date: <span style={{color: "seagreen"}}>{actionDate}</span></label>
                </div>
              </div>
            </Modal>
            <Modal title={<h4 className="content-label">Order {orderObj.action} confirmation</h4>} destroyOnClose={true} open={isConfirmModalOpen} onOk={handleConfirmOk} onCancel={handleConfirmCancel} style={{color: ""}}>
              <hr/>
              <div className="order-place-content">
                <span className="message-text">Please Note: Check your summary before continuing</span>
                <div className="content-section">
                  <label style={{fontWeight: "bold"}}>You are going to {orderObj.action} your  <span style={{color: "indianred"}}>{orderObj.meals.join(", ")}</span> order until Date: <span style={{color: "indianred"}}>{orderObj.till_date}</span></label>
                </div>
              </div>
            </Modal>

          </div>

          <div className="content_wrapper">
            <HomeTabLayout />
          </div>

          <FloatButton.BackTop tooltip="Move Up" />

        </LunchOrderContext.Provider>

      </BreakfastOrderContext.Provider>

    </>
  );
}
